import React from 'react';

import TemplateCard from 'Components/TemplateCard/TemplateCard';
import { removeSpacesAndHyphens } from 'helpers';

function CategoryTemplateCard({
  templates,
  setSelected,
  selected,
  handleTemplateClick,
}) {
  return templates.map((cardData) => {
    const { category_name } = cardData || {};
    const titleLower = cardData?.title?.toLowerCase() || '';
    const isXLogo = titleLower.includes('thread') || titleLower.includes('tweet');
    const isYouTube = titleLower.includes('youtube');
    const isTikTok = titleLower.includes('tiktok');
    const isWebinar = titleLower.includes('webinar');

    return (
      <TemplateCard
        ImageSrc={
          titleLower.includes('reel') ||
          titleLower.includes('carousel') ||
          titleLower.includes('instagram')
            ? '/Images/InstagramPosts.svg'
            : titleLower.includes('linkedin')
              ? '/Images/LinkedInLogo.svg'
              : isXLogo
                ? '/Images/x.svg'
                : isYouTube
                  ? '/Images/YouTubeScript.svg'
                  : isTikTok
                    ? '/Images/TikTokScript.svg'
                    : isWebinar
                      ? '/Images/WebinarScript.svg'
                      : titleLower.includes('email') ||
                          titleLower.includes('newsletter') ||
                          titleLower.includes('sequence')
                        ? '/Images/Email.svg'
                        : `/Images/${removeSpacesAndHyphens(cardData?.title)}.svg`
        }
        imageStyle={isXLogo ? { width: '14px', height: '14px' } : undefined}
        heading={cardData?.title}
        text={cardData?.description.slice(0, 200)}
        key={cardData?.id}
        id={cardData?.id}
        className={category_name.replace(/\s/g, '')}
        onClick={() =>
          handleTemplateClick
            ? handleTemplateClick(cardData?.id)
            : setSelected(cardData?.id)
        }
        selected={selected}
      />
    );
  });
}

export default CategoryTemplateCard;
